export default {
  getUserPin: (state) => state.userPin,
};
